import { useState, useEffect } from "react";
import axios from '../helper/axios';
import Autocomplete from "@mui/material/Autocomplete";
import {
    TextField,
    InputAdornment,
    IconButton,
} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { toast } from 'react-toastify';
import { useUser } from "../Provider";

const SearchNurse = ({ onSearchChanges, hospitalvalue }) => {
    const { user, userHospitalcode, userrole1, isAuthRole, isAuthorized, gettokenId, token } = useUser();
    const [value, setValue] = useState("");
    const [data, setDoctor] = useState([]);
    const [openAutocomplete, setOpenAutocomplete] = useState(false);

    useEffect(() => {
        const loadData = async () => {
            await getNurseDetails();
        };

        loadData();
    }, [userrole1, hospitalvalue]);

    const getNurseDetails = async () => {
        try {
            if (hospitalvalue !== undefined && userrole1 !== undefined) {
                const res = await axios.get(`/getnurse`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params: {
                        hospitalcode: hospitalvalue,
                        userrole: userrole1,
                    },
                });

                if (res.status === 200) {
                    setDoctor(res.data);
                } else {
                    alert(`Request failed with status: ${res.status}`);
                }
            }
        } catch (error) {
            if (error.request) {
                // toast.error("No response received from the server");
            } else {
                toast.error("Error:", error.message);
            }
        }
    };

    const onSearch = (searchTerms, item) => {
        onSearchChanges(item);
    };

    const handleExpandClick = () => {
        setOpenAutocomplete(!openAutocomplete);
    };

    return (
        <>
            <div className="searchbar">
                <Autocomplete
                    freeSolo
                    id="free-solo"
                    options={data}
                    getOptionLabel={(option) => `${option.fname}`}
                    open={openAutocomplete}
                    onOpen={() => setOpenAutocomplete(true)}
                    onClose={() => setOpenAutocomplete(false)}
                    onChange={onSearch}
                    renderInput={(params) =>
                        <TextField
                            {...params}
                            placeholder="Select Nurse"
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={handleExpandClick}>
                                            <ExpandMoreIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    }
                    renderOption={(props, option) => (
                        <li {...props}>
                            {option.fname}
                        </li>
                    )}
                />

            </div>
        </>
    );
}

export default SearchNurse;
